import moment from "moment-timezone";
import { SchedulerStoreType } from "../state/scheduler.store";
import { last } from "lodash-es";

export const navigateWeek = (
  direction: "previous" | "next",
  sessionData: SchedulerStoreType["sessionData"],
  actions: SchedulerStoreType["actions"],
  allAvailableDates?: string[]
) => {
  const availableDates =
    allAvailableDates ??
    sessionData?.computedAvailability?.map((a) => a.date) ??
    [];

  let weekFirstAvailableDate: string | null = null;

  if (direction === "next") {
    const currentWeek = moment(sessionData?.selectedSlot?.date).week();
    weekFirstAvailableDate =
      availableDates.find(
        (date) =>
          moment(date).week() !== currentWeek &&
          moment(date).isAfter(sessionData?.selectedSlot?.date)
      ) ?? null;
  }

  if (direction === "previous") {
    const currentWeek = moment(sessionData?.selectedSlot?.date).week();
    weekFirstAvailableDate =
      [...availableDates]
        .reverse()
        .find(
          (date) =>
            moment(date).week() !== currentWeek &&
            moment(date).isBefore(sessionData?.selectedSlot?.date)
        ) ?? null;
  }

  actions.setSessionData({
    ...sessionData,
    selectedSlot: {
      date: moment(
        weekFirstAvailableDate ?? sessionData?.selectedSlot?.date
      ).valueOf(),
      hour: null,
      minute: null
    }
  });
};

export const disableDateNavButton = (
  direction: "previous" | "next",
  sessionData: SchedulerStoreType["sessionData"],
  allAvailableDates?: string[]
) => {
  return moment(sessionData?.selectedSlot?.date).isSame(
    moment(
      direction === "next"
        ? allAvailableDates
          ? last(allAvailableDates)
          : last(sessionData?.computedAvailability)?.date
        : allAvailableDates
          ? allAvailableDates[0]
          : sessionData?.computedAvailability?.[0]?.date
    ),
    "week"
  );
};
